import { Transformer } from '@is24at/react-transformers';
import {
  companyName,
  addressLines,
  streetString,
  city,
  countryCode,
  zipCode,
  phoneNumbers,
  logoUrl,
  badges,
  website,
  proRealtorImageUrl,
  proRealtorAboutUsText,
  features,
  exposePath,
  cwid,
} from 'core/transformers';
import { byImageResizeUrl } from 'selectors';

const exposeTransformer = (expose, state) => ({
  view: new Transformer({
    companyName,
    addressLines,
    phoneNumbers,
    logoUrl: (arg: any) => logoUrl(arg, byImageResizeUrl(state)),
    badges,
    website,
    features,
    proRealtorImageUrl,
    proRealtorAboutUsText,
    streetString,
    city,
    countryCode,
    zipCode,
    exposePath,
    cwid,
  }).transform(expose),
});

export default exposeTransformer;
